export const pecaPageRows = 30;
export const pecaRowsPerPageOptions = [30, 50, 100, 200];
